var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex mx-auto mb-2 border border-gray-300 rounded-sm"},[_c('div',{staticClass:"p-2"},[_vm._v("\n\t\tDeal\n\t")]),_vm._v(" "),_c('div',{staticClass:"flex-1 p-2"},[_vm._v("\n\t\t"+_vm._s(_vm.deal.title)+"\n\t")]),_vm._v(" "),_c('div',{staticClass:"p-2"},[_vm._v("\n\t\t"+_vm._s(_vm.deal.display_price)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }